<script setup lang="ts">
import { useNotificationStore } from '@/stores/notifications'

const store = useNotificationStore()

const typeStyles = {
  success: 'border-status-success bg-status-success-light dark:bg-green-900/30',
  error: 'border-status-danger bg-status-danger-light dark:bg-red-900/30',
  warning: 'border-status-warning bg-status-warning-light dark:bg-yellow-900/30',
  info: 'border-brand-teal bg-status-info-light dark:bg-teal-900/30',
}
</script>

<template>
  <div
    aria-live="polite"
    aria-atomic="true"
    class="fixed top-4 right-4 z-[100] flex flex-col gap-2 w-full max-w-sm"
  >
    <TransitionGroup
      enter-active-class="transition-all duration-300 ease-out"
      enter-from-class="opacity-0 translate-x-4"
      enter-to-class="opacity-100 translate-x-0"
      leave-active-class="transition-all duration-200 ease-in"
      leave-from-class="opacity-100 translate-x-0"
      leave-to-class="opacity-0 translate-x-4"
    >
      <div
        v-for="toast in store.toasts"
        :key="toast.id"
        :class="[
          'p-4 rounded-lg border-l-4 shadow-lg bg-white dark:bg-surface-800',
          typeStyles[toast.type],
        ]"
        role="alert"
      >
        <div class="flex items-start justify-between gap-2">
          <div>
            <p class="text-sm font-medium text-surface-900 dark:text-surface-100">
              {{ toast.title }}
            </p>
            <p v-if="toast.message" class="mt-1 text-xs text-surface-600 dark:text-surface-400">
              {{ toast.message }}
            </p>
          </div>
          <button
            class="flex-shrink-0 p-1 rounded text-surface-400 hover:text-surface-600 dark:hover:text-surface-200"
            aria-label="Dismiss notification"
            @click="store.removeToast(toast.id)"
          >
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>
    </TransitionGroup>
  </div>
</template>
